<template>
	<div class="os_choice_block">
		<b-row class="doc_title">
			<b-col sm="3">
				<label :for="os_field.type + os_field.id">{{os_field.name}} </label>
			</b-col>

			<b-col sm="6">
				<div class="os_block" >
					<v-select v-model="os_field.insert_val"
							  @search="onSearch"
							  @input="on_select_os"
							  class="imc_reasons"
							  label="name"
							  :options="os_search_options"
							  :filterable="false"
					>
						<template slot="no-options">
							Пошук ОС
						</template>

						<template slot="option" slot-scope="option">
							<div class="d-center">
								<div>
									{{ option.name }} ( {{option.gosNomer}})
								</div>
								<div>
									<small >
										{{option.zavNomer}} - {{option.invNomer}}
									</small>
								</div>

							</div>
						</template>
					</v-select>
				</div>
			</b-col>
		</b-row>

		<div class="addon_fields_main">
			<div class="auction_land_fields">
				<b-container fluid v-if="draw_fields.length > 0">
					<div class="main_info">
						<b-row class="doc_title" :key="field.id" v-for="field in this.draw_fields">
							<b-col sm="3">
								<label :for="field.type + field.id">{{field.name}} </label>
							</b-col>
							<b-col sm="6">
								<b-form-input
									v-if="field.type == 'input'"
									type="text"
									class="fs-xl"
									:readonly="check_if_locked(field)"
									:state="is_valid_field(field)"
									v-model="field.insert_val"
									:id="field.type + field.id"
									size="sm" >
								</b-form-input>

								<v-select
									taggable
									:create-option="book => ({ label: book ,value : book})"
									v-model="field.insert_val"
										  v-if="field.type == 'mech_select'"
										  class="imc_reasons"
										  label="label"
									      :reduce="item => item.value"
										  :options="ekipag_options"
								>
									<template slot="no-options">
										Оберіть Механізатора
									</template>
									<template slot="option" slot-scope="option">
										<div class="d-center">
											{{ option.label }}
										</div>
									</template>
								</v-select>
							</b-col>
						</b-row>
					</div>
				</b-container>
			</div>
		</div>
	</div>

</template>

<script>

import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
    getterType: 'memorandum_create/getMemCreateField',
    mutationType: 'memorandum_create/updateMemCreateField',
});
import vSelect from 'vue-select'
export default {
	name: "os_choice",
	props  : {
		os_field : {
			type : Object,
		}
	},
	components: {
		vSelect
	},
	data() {
		return {
			os_search_options : [],
			os_ekipag : [],

		}
	},

	methods : {
		check_if_locked(field) {
			if(field.insert_type == 'motoChasi') {
				return false;
			}
			return true;
		},

		is_valid_field(field)  {

		},

		onSearch(search,loading) {
			if(search.length > 2) {
				loading(true);
				this.search(loading, search);
			}
		},

		on_select_os(item) {

			console.log(item);
			this.os_ekipag = [];

			this.draw_fields.map(field => {
				field.insert_val = '';

				if(field.insert_type != 'ekipag') {
					if (item.hasOwnProperty(field.insert_type)) {
						field.insert_val = item[field.insert_type];
					}
				}
				else {
					this.os_ekipag = item[field.insert_type];
					if(this.obj_to_null(this.os_ekipag) && this.os_ekipag.length == 1) {
						field.insert_val = this.os_ekipag[0];
					}
				}
			});

		},

		async search(loading, search)  {
			let self = this;
			api.post('/parts/os_by_tov/' + this.active_mem.form.tov_id +'/', {
				"search" : search
			}).then(({data}) => {
				console.log(data);
				if(data.status === 'operation_success') {
					loading(false);
					self.os_search_options = data.data;
				}
			}).catch(({response}) => {
				loading(false);
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,	position : "b-toaster-top-left"})
			});
		},
	},

	computed : {
        
        
        ...mapFields([
            'active_memorandum'
        ]),
        
		active_mem() {
			return this.active_memorandum;
		},
  
		ekipag_options () {
			return this.os_ekipag.map(function(man){
				return {
					"label" : man,
					'value' : man
				}
			})
		},

		os_fields() {
			return this.os_field.fields;
		},

		draw_fields() {
			return this.os_fields.filter(function(item){
				return true;//item.type == 'input';
			});
		},

		os_selected () {

		},
	}
}
</script>

<style scoped>

</style>
